import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  filters: [],
  visibleColumns: [],
};

export const batchResultSlice = createSlice({
  name: "batchResult",
  initialState,
  reducers: {
    setBatchFilters: (state, action) => {
      state.filters = action.payload;
    },
    setBatchVisibleColumns: (state, action) => {
      state.visibleColumns = action.payload;
    },
  },
});

export const { setBatchFilters, setBatchVisibleColumns } = batchResultSlice.actions;
export default batchResultSlice.reducer;